<script>
import Repositories from '@/repositories';
const ItemSupplierPriceHistoriesRepository = Repositories.get(
  'itemsupplierpricehistories'
);
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import dateMixin from '@/mixins/dateMixin';

export default {
  components: {
    Loading,
  },
  props: {
    itemSupplierIdPublic: { type: String, default: null },
  },
  mixins: [dateMixin],
  data() {
    return {
      itemSupplierPriceHistoriesList: [],
      isLoading: false,
    };
  },
  methods: {
    modalHidden() {
      this.itemSupplierPriceHistoriesList = [];
      this.isLoading = false;
      this.$emit('modal-closed');
    },
    modalShown() {
      this.itemSupplierPriceHistoriesList = [];
      this.isLoading = true;

      ItemSupplierPriceHistoriesRepository.customREST
        .getByItemSupplier(this.itemSupplierIdPublic)
        .then((response) => {
          this.itemSupplierPriceHistoriesList = response.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
    precentCalcul(priceHistory) {
      if (priceHistory.price - priceHistory.difference != 0) {
        return this.toFloat(
          this.toFloat(priceHistory.price * 100) /
            this.toFloat(priceHistory.price - priceHistory.difference) -
            100
        ).toFixed(2);
      } else {
        return 100;
      }
    },
  },
  computed: {
    priceHistoriesSorted() {
      return this.itemSupplierPriceHistoriesList.slice().reverse((a, b) => {
        return new Date(b.created) - new Date(a.created);
      });
    },
    currencyFormatter() {
      return this.$store.state.cache.currencyFormatter;
    },
  },
};
</script>

<template>
  <div>
    <b-modal
      id="price-histories-modal"
      scrollable
      size="xl"
      :title="$t('pricehistories.pricehistories')"
      @shown="modalShown()"
      @hide="modalHidden()"
      ok-variant="danger"
    >
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#f1b44c"
        :width="70"
        :height="70"
        loader="dots"
        :is-full-page="false"
      >
      </loading>

      <div v-if="currencyFormatter != null">
        <table class="table table-hover table-nowrap">
          <thead class="thead-light">
            <tr>
              <th class="table-row-expandable">
                {{ $t('general.price') }}
              </th>
              <th class="table-row-relative">
                {{ $t('general.difference') }}
              </th>
              <th class="table-row-relative">
                {{ $t('general.percentage') }}
              </th>
              <th class="table-row-relative">
                {{ $t('general.date') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="priceHistory in priceHistoriesSorted"
              :key="priceHistory.idPublic"
            >
              <td class="table-row-expandable">
                {{ currencyFormatter.format(priceHistory.price) }}
              </td>
              <td class="table-row-relative">
                {{ currencyFormatter.format(priceHistory.difference) }}
              </td>
              <td class="table-row-relative">
                {{ precentCalcul(priceHistory) + '%' }}
              </td>
              <td class="table-row-relative">
                {{ formatDateShort(priceHistory.created) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <template #modal-footer>
        <b-button
          @click="$bvModal.hide('price-histories-modal')"
          size="sm"
          variant="danger"
        >
          {{ $t('general.close') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
